import { useTranslation } from 'react-i18next';
import { DesignIcon } from '@monorepo/nova-icons';
import { LinearProgress, Stack, Typography, useTheme } from '@monorepo/nova-ui';

export const CodeCheck = () => {
  const theme = useTheme();
  const { t } = useTranslation(['mailConfirmationNova']);

  return (
    <Stack
      textAlign="center"
      alignItems={'center'}
      direction={'column'}
      gap={6}
    >
      <DesignIcon
        iconName={'HandsClap'}
        sx={{ fontSize: theme.typography.pxToRem(200) }}
        useMuiSvgIcon={false}
      />
      <Typography variant={'h3'} textAlign="center">
        {t('mailConfirmationNova:verifying_title')}
      </Typography>
      <Typography textAlign="center">
        {t('mailConfirmationNova:verifying_subtitle')}
      </Typography>
      <LinearProgress sx={{ width: '40%' }} />
    </Stack>
  );
};
